import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=515a48af"
import script from "./MediaModal.vue?vue&type=script&lang=ts"
export * from "./MediaModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports